import { EditOutlined, TaskAltOutlined } from '@mui/icons-material';
import {
    Box,
    CircularProgress,
    IconButton,
    InputAdornment,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { OverallDataContext } from '../../pages/CalculatorPage';


export default function OffsetInputField({ setNetEmissions_output }) {
    // Context data
    const outputData = useContext(OverallDataContext).outputData[0];
    const handleSubmit = useContext(OverallDataContext).handleSubmitButtonPress;
    
    // User input
    const [inputCarbonOffset, setInputCarbonOffset] = useContext(OverallDataContext).inputCarbonOffset;

    // UI flags
    const isLoading = useContext(OverallDataContext).isLoading;
    const [errorMsg, setErrorMsg] = useState('');
    const [isLocked, setIsLocked] = useState(false);

    const handleSubmitWithOffset = () => {
        if (inputCarbonOffset) {
            const totalEmissions_output = outputData?.breakdown?.['41_total_emissions']?.value;
            if (isNaN(parseFloat(inputCarbonOffset)) || parseFloat(inputCarbonOffset) > parseFloat(totalEmissions_output)) {
                setErrorMsg("Invalid offset value.");
            } else {
                setErrorMsg('');
                handleSubmit();
            }
        } else setIsLocked(true);
    }
    
    useEffect(() => {
        setIsLocked( outputData?.offset?.value || true );
        setInputCarbonOffset(outputData?.offset?.value)
        setNetEmissions_output(parseFloat(outputData?.net?.value).toLocaleString('en-US', {maximumFractionDigits: 0}))
    }, [outputData]);
    
    return (
        <>
        <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
        {
        isLocked ?
        <>
            <IconButton className='submit_button hide-on-print' onClick={() => setIsLocked(false)} size='small' >
            <EditOutlined />
            </IconButton>
            <Box>{parseFloat(inputCarbonOffset).toLocaleString('en-US', {maximumFractionDigits: 0})}</Box>
        </>
        :
        <>
            <TextField 
                id="inputCarbonOffset" 
                value={inputCarbonOffset} 
                onChange={(e) => setInputCarbonOffset(e.target.value)}
                error={(errorMsg !== '')}
                size='small'
                sx={{ backgroundColor: 'white', borderRadius: '24px' }}
                InputProps={{
                    endAdornment: <InputAdornment position="end">kg CO&#8322;e</InputAdornment>
                }}
            />
            { isLoading ?
                <CircularProgress color='inherit' size={20} />
            :
                <IconButton className='submit_button' onClick={handleSubmitWithOffset} size='small' >
                <TaskAltOutlined />
                </IconButton>
            }
            <Box className='show-on-print'>{inputCarbonOffset}</Box>
        </>
        }
        </Stack>
        {
            errorMsg &&
            <Typography variant='caption' color='#f00'>
                {errorMsg}
            </Typography>
        }
        </>
    )
}